import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';
import {signOut} from 'services/firebase-service';

const ConfirmLogout = (props: DialogProps) => {
  const {toggle, modalOpen} = props;

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="dialog-logout">
      <DialogTitle id="dialog-title">
        ¿Estas seguro de cerrar sesión?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Una vez lo hagas, perderas todos los cambios del torneo en donde te
          encuentras si no los has guardado
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>
        <Button onClick={signOut} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmLogout;
